import ArrowsSpinIcon from 'src/icons/ArrowsSpin';
import PuzzlePiece from 'src/icons/PuzzlePiece';
import LightBulb from 'src/icons/LightBulb';
import FileCode from 'src/icons/FileCode';
import FileLines from 'src/icons/FileLines';
import DraftingCompass from 'src/icons/DraftingCompass';
import ListCheck from 'src/icons/ListCheck';
import ObjectGroup from 'src/icons/ObjectGroup';
import PenRuler from 'src/icons/PenRuler';
import Cube from 'src/icons/Cube';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import GoogleDriveIcon from 'src/icons/GoogleDrive';
import BriefcaseIcon from 'src/icons/Briefcase';
import FileInvoiceDollarIcon from 'src/icons/FileInvoiceDollar';
import FilePowerpointIcon from 'src/icons/FilePowerpoint';
import GithubIcon from 'src/icons/Github';
import SalesforceIcon from 'src/icons/Salesforce';

export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  NATURE: 'NATURE'
};

export const STORAGE_KEYS = {
  USER: 'BS-user', // @todo: need to implement
  APP_SETTINGS: 'BS-settings',
  THEME_SWITCHER: 'BS-theme-switcher-intro',
  PS_LIBRARY_DISPLAY: 'BS-ps-library-display-mode'
};

export const PS_ASSET_TYPE_ICONS = {
  solution: LightBulb,
  component: PuzzlePiece,
  code: FileCode,
  template: FileLines,
  architecture: DraftingCompass,
  tdd: ArrowsSpinIcon,
  qa_assets: ListCheck,
  ui_ux: PenRuler,
  functional_design: ObjectGroup,
  others: Cube
};

export const PS_ASSET_FILE_ICONS = {
  tdd: ArrowsSpinIcon,
  slides: FilePowerpointIcon,
  demo: SlideshowIcon,
  github: GithubIcon,
  sow: BriefcaseIcon,
  quick_quote: FileInvoiceDollarIcon,
  google_drive_folder: GoogleDriveIcon,
  salesforce_opportunity_detail: SalesforceIcon
};

export const PS_ASSET_FILE_COLORS = {
  tdd: '#795548',
  slides: '#ff5722',
  demo: '#9c27b0',
  github: '#673ab7',
  sow: '#3f51b5',
  quick_quote: '#2196f3',
  google_drive_folder: '#009688',
  salesforce_opportunity_detail: '#afb42b'
};

export const PS_ASSET_TYPE_AVATAR_COLORS = {
  solution: '#795548',
  component: '#ff5722',
  code: '#9c27b0',
  template: '#673ab7',
  architecture: '#3f51b5',
  tdd: '#2196f3',
  qa_assets: '#00bcd4',
  ui_ux: '#009688',
  functional_design: '#4caf50',
  others: '#afb42b'
};

export const PS_ASSET = {
  ROWS_PER_PAGE: 50
};

export const MESSAGES = {
  errorMessage: `An error occurred while processing your request, we don’t know
    what happened yet but this is automatically reported. You can also
    contact us via our Slack channel #ask-bootstrapper or via chat
    widget. Thank you for your patience.`,
  systemNotificationMessage: `Bootstrapper Team will be performing major updates to 
    the platform during the scheduled maintenance on 28th December 10:00PM to 11:00PM (+8 GMT). 
    During the maintenance period, brief disruption of Bootstrapper services is expected.`,
  failedNoticeText: `It looks like you have encountered some backend errors from Zendesk APIs. 
    If you retry the Bootstrapper Job, you would end up with duplicated resources. 
    Please only retry (and delete the duplications) if missing resources are critical for your demo.`
};

export const DEFAULT_IMAGES = {
  template: {
    default:
      '/static/images/default-images/template-banner/template-default.png'
  },
  app: {
    default:
      '/static/images/default-images/apps-marketplace-banner/apps-marketplace-default.png',
    support:
      '/static/images/default-images/apps-marketplace-banner/support-default.png',
    guide:
      '/static/images/default-images/apps-marketplace-banner/guide-default.png',
    chat:
      '/static/images/default-images/apps-marketplace-banner/chat-default.png',
    sunshine:
      '/static/images/default-images/apps-marketplace-banner/sunshine-default.png'
  },
  mobileApp: {
    default: '/static/images/default-images/mobile-app-banner/mobile-app-default.png',
    android:
      '/static/images/default-images/mobile-app-banner/mobile-app-android.png',
    ios: '/static/images/default-images/mobile-app-banner/mobile-app-ios.png',
    androidAndIos:
      '/static/images/default-images/mobile-app-banner/mobile-app-ios-android.png',
  },
  snippet: {
    default: '/static/images/default-images/snippet-banner/snippet-default.png',
    support: '/static/images/default-images/snippet-banner/support-snippet.png',
    guide: '/static/images/default-images/snippet-banner/guide-snippet.png',
    chat: '/static/images/default-images/snippet-banner/chat-snippet.png',
    other: '/static/images/default-images/snippet-banner/other-snippet.png'
  },
  ps_asset: {
    default:
      '/static/images/default-images/ps-asset-banner/ps-asset-default.png'
  },
  service: {
    default: '/static/images/default-images/service-banner/service-default.png'
  },
  approval: {
    default: '/static/images/default-images/approval-banner/approval-default.png'
  },
  default: '/static/images/default-images/default.png'
};

export const REGIONS = [
  {
    slug: 'apac',
    name: 'APAC'
  },
  {
    slug: 'emea',
    name: 'EMEA'
  },
  {
    slug: 'amer',
    name: 'AMER'
  },
  {
    slug: 'latam',
    name: 'LATAM'
  }
];
